import Vue from 'vue'
import VueRouter from 'vue-router'
import maintenance from '../components/maintenance'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'maintenance',
    component: maintenance,
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
